var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsuccesful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.04,
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    fill: "#FF0F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6535 45.4109C48.482 44.2393 46.5825 44.2393 45.4109 45.4109C44.2393 46.5825 44.2393 48.482 45.4109 49.6535L55.2574 59.5L45.4109 69.3465C44.2393 70.5181 44.2393 72.4176 45.4109 73.5891C46.5825 74.7607 48.482 74.7607 49.6535 73.5891L59.5 63.7427L69.3465 73.5891C70.5181 74.7607 72.4176 74.7607 73.5891 73.5891C74.7607 72.4176 74.7607 70.5181 73.5891 69.3465L63.7427 59.5L73.5891 49.6535C74.7607 48.482 74.7607 46.5825 73.5891 45.4109C72.4176 44.2393 70.5181 44.2393 69.3465 45.4109L59.5 55.2574L49.6535 45.4109Z",
    fill: "#FF0F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsuccesful);
export default __webpack_public_path__ + "static/media/unsuccesful.7644424f82ef74cb2b851c1bc3ccd141.svg";
export { ForwardRef as ReactComponent };